import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AnagraficaForm } from '../../../form/anagrafica-form';
import { AnagraficaResponse } from '../../../models/dto/anagrafica-response';
import { Legale } from '../../../models/legale';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { FormValidationService } from '../../../services/form-validation.service';
import { LegaleAdapter } from './legale-adapter';

@Component({
    selector: 'div [legali-anagrafica-form-update]',
  templateUrl: '../../../form/anagrafica-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class LegaleAnagraficaUpdate extends AnagraficaForm implements OnInit {
  legaleIncaricato: LegaleIncaricato;
  sezione: SezioneLegali;
  urlUpdate: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<Legale> = new EventEmitter<Legale>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica legale - Anagrafica');
    this.isInserimento(false);
  }

  datiAanagraficaLegale(response: AnagraficaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.anagrafiche[0] as Legale);
    }
  }

  inizializza(urlUpdate: string, legaleIncaricato: LegaleIncaricato, sezione: SezioneLegali) {
    this.legaleIncaricato = legaleIncaricato;
    this.sezione = sezione;
    this.populateSelect();
    this.createForm();
    this.urlUpdate = urlUpdate;
  }

  getAdapter(): Legale {
    return new LegaleAdapter(this.legaleIncaricato.legale).legale;
  }

  getRequest(request: Legale) {
    this.operationService.setLegaleInSezLegale(this.urlUpdate, request).subscribe(response => this.datiAanagraficaLegale(response));
  }

  hasConvenzione(): boolean {
      return true;
  }

  hasTariffa(): boolean {
      return true;
  }

  hasDipendete(): boolean {
      return false;
  }

  hasMatricola(): boolean {
    return false;
  }

  hasAmbitiCompetenza(): boolean {
    return true;
  }

  getTipoPratica(){

  }
}
